import classNames from 'classnames/bind'

import {formatTimestamp} from '../../helpers'
import {LogValueList} from '../common'

import styles from './Item.module.scss'

import type {Trace} from '../../trace/type'
import type {FC} from 'react'

const cx = classNames.bind(styles)

interface ItemProps {
    trace: Trace
}

const Item: FC<ItemProps> = ({trace}) => {
    return (
        <li key={trace.id} className={cx('item')}>
            <div className={cx('row')}>
                <span className={cx('scope')}>{trace.scope}</span>
                {trace.message.length > 0 && (
                    <span className={cx('data')}>
                        <LogValueList nodes={trace.message} />
                    </span>
                )}
                <time className={cx('time')} dateTime={new Date(trace.timestamp).toISOString()}>
                    {formatTimestamp(trace.timestamp)}
                </time>
            </div>
        </li>
    )
}

export default Item
